











import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalUploadCSV from './ModalUploadCSV.vue';

import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi,
    parseFloatNumber,
    timestampToTime
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import { booleanFormatter, getOnlyDateFromTimestamp, nullFormatter } from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalManualFactor from './ModalManualFactor.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { set } from 'tiny-cookie';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
exportingInit(Highcharts);

@Component({
    components: {
        highcharts: Chart
    }
})
export default class CalibrationPeriods extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    calibrationPeriods: Array<object>;
    visibleChart: boolean = false;
    chartOptions: object = {};

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.setCalibrationPeriodsCharts();
        });
    }

    setCalibrationPeriodsCharts() {
        this.visibleChart = false;
        let pointsPerformance = this.getParsedCalibrationPeriods(this.calibrationPeriods, true);
        let pointsHumidity = this.getParsedCalibrationPeriods(this.calibrationPeriods, false);

        let series = [
            {
                pointWidth: 20,
                data: pointsPerformance,
                name: 'Rendimiento',
                type: 'line',
                yAxis: 0,
                dataLabels: {
                    enabled: true,
                    valueDecimals: 3,
                    formatter: function() {
                        return this.point.y + '%';
                    }
                }
            },
            {
                type: 'line',
                name: 'Humedad',
                yAxis: 1,
                pointWidth: 20,
                data: pointsHumidity,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        return this.point.y + '%';
                    }
                }
            }
        ];

        this.chartOptions = {
            xAxis: {
                type: 'datetime',
                labels: {
                    format: '{value:%e/%m/%y %H:%M:%S}',
                    style: {
                        width: 80
                    }
                }
            },
            time: {
                useUTC: false
            },
            yAxis: [
                {
                    title: {
                        text: 'Rendimiento'
                    }
                },
                {
                    title: {
                        text: 'Humedad'
                    },
                    opposite: true
                }
            ],
            chart: {
                type: 'column',
                zoomType: 'x'
            },
            title: {
                text: ''
            },
            series: series
        };

        let chartReference = this.$refs.calibrationPeriodsChart as HTMLFormElement;
        setTimeout(() => {
            this.visibleChart = true;
            chartReference.chart.redraw();
        }, 700);
    }

    getParsedCalibrationPeriods(periods, isPerformance) {
        let points: any = [];

        for (let i = 0; i < periods.length; i++) {
            let item = periods[i];
            let calFactorPercent = isPerformance
                ? item['performance_cal_factor_percent']
                : item['humidity_cal_factor_percent'];
            let calFactorValue = Number(parseFloatNumber(calFactorPercent));
            let itemToPush = [
                {
                    x: timestampToTime(item['start_date']),
                    y: calFactorValue
                },
                {
                    x: timestampToTime(item['end_date']),
                    y: calFactorValue
                }
            ];
            points = [...points, ...itemToPush];
        }
        return points;
    }
}
